import { i } from '../lit-element.js';

const links = i`
  .grv-link {
    color: #255f82;
    text-decoration: underline;
  }

  .grv-link:visited {
    color: #255f82;
  }

  .grv-link:hover {
    color: #013d5b;
  }

  .grv-link:active {
    color: #10253f;
  }
`;

export { links };
